
<template>
    <el-dialog title="邮寄地址" :visible.sync="dialogvisible"
     custom-class="ftpDialog" width="25%" append-to-body :close-on-click-modal="false">
        <div class="ftpList">
            <span style="display:block;margin : 5px 0 5px 30px;">如果您要添加新的地址，请前往<router-link to="/home/address" style="color:red;">邮寄地址管理</router-link></span>
            <el-radio-group v-model="addressId">
                <el-radio v-for="(item,index) in addressList" :key="index"
                 :label="index" @change="handleRadio" style="display:block;margin : 5px 0 15px 30px;">
                    <span>{{ addressDetail(item) }}</span>
                </el-radio>
            </el-radio-group>
            <div style="margin-top: 20px;text-align: center;">
                <el-button
                type="danger" round
                style="padding: 10px 30px"
                @click="ftpSelect">确认选择，提交订单</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
  name: 'AddressListDialog',
  props: ['addressDialogvisible', 'addressList'],
  data () {
    return {
      dialogvisible: false,
      addressId: 0
    }
  },
  methods: {
    addressDetail(item) {
      let addressDetail = item.address_detail + item.address
      addressDetail = addressDetail.replace(/\s*/g, '')
      return addressDetail
    },
    ftpSelect() {
      this.$emit('getAddressId', this.addressList[this.addressId].id)
      this.dialogvisible = false
      this.$emit('commitOrder')
    },
    handleRadio(val) {
      this.addressId = val
    }
  },
  watch: {
    addressDialogvisible(val) {
      this.dialogvisible = val
    },
    dialogvisible(val) {
      this.$emit('onAddressDialogvisible', val)
    }
  }
}
</script>
<style lang="less">
.ftpDialog {
    position: relative;
    margin: 0 auto 50px;
    border-radius: 8px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    min-width: 350px;
    .el-dialog__header {
        background: #FFF;
        border-radius: 8px 8px 0 0;
        height: 1.25rem;
        .el-dialog__title {
            line-height: 24px;
            font-size: 18px;
            color: #303133;
        }
        .el-dialog__headerbtn .el-dialog__close {
            color: #909399;
        }
    }
    .ftpList{
        border-top: 1px #dcdfe6 solid;
        .el-radio-group{
            .el-radio__input.is-checked{
              .el-radio__inner {
                border-color: red;
                background: red;
              }
            }
            .el-radio__input.is-checked+.el-radio__label {
              color: #606266;
            }
            label{
              box-sizing: border-box;
            }
            label:hover{
                background:#f4f5f7;
                border:1px solid #f00802;
                box-sizing: border-box;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/account/PostAddressList.vue